import Episode from "@/containers/Episode";
import Episodes from "@/containers/Episodes";
import { AudioPlayerContextProvider } from "@/contexts/GlobalAudioPlayerContext";

import { BaseWidget } from "../BaseWidget";
import { sumArray } from "../helpers";

import styles from "./MentionsWidget.module.css";

const hasData = (data) => {
  return (
    data &&
    data.map((d) => (d.episodesWithMentions || []).length).reduce(sumArray, 0) >
      0
  );
};

export const MentionsWidget = (props) => {
  let episodes = [];

  if (hasData(props.data)) {
    episodes = props.data[0].episodesWithMentions;
  }

  return (
    <BaseWidget {...props} hasData={hasData(props.data)}>
      <div className={styles.chartWrapper}>
        {hasData(props.data) ? (
          <AudioPlayerContextProvider>
            <Episodes>
              {episodes.map((episode, i) => (
                <Episode
                  key={i}
                  {...episode}
                  hideActions
                  hideSimilar
                  hideTags
                  visibleMentions={2}
                />
              ))}
            </Episodes>
          </AudioPlayerContextProvider>
        ) : null}
      </div>
    </BaseWidget>
  );
};
